import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useViewNewsArticle } from "../../hooks";
import { FILE_PATH } from "../../config";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import { TITLE } from "../../helpers/seo";
import { Helmet } from "react-helmet";
const NewsArticlePage = () => {
  const { id } = useParams();
  const [data, setData] = useState("");
  const [otherNews, setOtherData] = useState("");

  console.log("id", id);
  const { refetch } = useViewNewsArticle(id, ({ data: news }) => {
    if (news) {
      setData(news.data);
      setOtherData(news.data1);
    }
  });
  useEffect(() => {
    refetch();
  }, [id, refetch]);
  console.log(data, otherNews, "news");
  const removeHTMLTags = (input) => {
    if (typeof input === "string" || input instanceof String) {
      const div = document.createElement("div");
      div.innerHTML = input;

      const allowedTags = [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "ol",
        "ul",
        "li",
        "strong",
        "em",
        "br",
        "p",
        "div",
        "a",
        "img",
        "figure",
      ];

      const sanitizeNode = (node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (!allowedTags.includes(node.tagName.toLowerCase())) {
            node.remove();
            return;
          }

          if (node.tagName.toLowerCase() === "a") {
            node.setAttribute("style", "color: #ff8c00;");
          } else if (node.tagName.toLowerCase() === "img") {
            node.setAttribute("class", "blog-image-left");
          } else if ([].includes(node.tagName.toLowerCase())) {
            node.setAttribute("class", "blog-text-right");
          }

          for (let i = node.childNodes.length - 1; i >= 0; i--) {
            sanitizeNode(node.childNodes[i]);
          }
        }
      };

      for (let i = div.childNodes.length - 1; i >= 0; i--) {
        sanitizeNode(div.childNodes[i]);
      }

      return div.innerHTML;
    } else {
      return input;
    }
  };

  return (
    <div>
      <Helmet>
        <title>News & Events | {TITLE}</title>
        <meta
          name="description"
          content="Stay updated with the latest news and events."
        />
        <meta property="og:title" content="News & Events" />
        <meta
          property="og:description"
          content="Stay updated with the latest news and events."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <style>{`
        .blog-image-left {
          width: 100%; /* Adjust the width as needed */
          height: 350px; /* Fixed height */
          object-fit: contain; /* Ensures the entire image fits within the container without stretching */
        }
        .post-meta {
          overflow: hidden; /* Ensure content stays within the card */
          padding: 20px; /* Add padding for better appearance */
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visual separation */
          border-radius: 8px; /* Optional: Add rounded corners */
          background-color: #fff; /* Optional: Set background color */
          margin-bottom: 20px; /* Optional: Add space between cards */
        }
        .blogArticle ol {
          list-style-type: auto;
          margin-left: 18px;
        }
        .blogArticle ul {
          list-style-type: disc;
          margin-left: 18px;
        }

        .blog-text-right {
          float: right;
          width: 100%; /* Adjust width as needed */
        }
        .fixed-size-image {
          width: fit-content;
          // height: 200px; /* Fixed height */
          object-fit: contain; /* Ensures the entire image fits within the container without stretching */
        }
      `}</style>

      <div className="fancy-hero-three">
        <div className="bg-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 col-lg-10 m-auto">
                <h1 className="heading">News Brief</h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.bg-wrapper  */}
      </div>

      {/* <div className="fancy-text-block-thirteen pt-100 md-pt-100">
        <div
          className="container"
          data-aos="fade-left"
          data-aos-duration="1200"
        >
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-last">
              <div className="text-wrapper">
                <div className="title-style-two">
                  <h2>{data?.title}</h2>
                </div>
                <p>{removeHTMLTags(data.description)}</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-8 m-auto order-lg-first">
              <img
                src={`${FILE_PATH}/news/${data.images}`}
                alt="feature"
                className="image-meta mx-auto d-block"
              />
            </div>
          </div>
        </div>
      </div> */}

      <div className="blog-page-bg">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 offset-xl-2 col-lg-12 feature-blog-one width-lg blog-details-post-v1">
              <div className="post-meta blogArticle">
                <img
                  src={`${FILE_PATH}/news/${data.images}`}
                  alt="feature"
                  className="fixed-size-image"
                />
                {/* <div className="tag">{data?.category}</div> */}
                <h3 className="title" style={{ marginTop: "20px" }}>
                  {data?.title}
                </h3>
                {/* Render HTML content safely */}
                <div
                  style={{ marginTop: "20px" }}
                  dangerouslySetInnerHTML={{
                    __html: removeHTMLTags(data.description),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="feature-blog-one pt-15 pb-15 md-pt-15 md-pb-15">
        <div className="container">
          <div className="row">
            <div className="m-auto">
              <div className="title-style-one text-center mb-50 md-mb-20">
                <h2>Read The Other News</h2>
              </div>
              {/* /.title-style-one */}
            </div>
          </div>
          <div className="row justify-content-center">
            {otherNews &&
              otherNews.map((item, i) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={i}
                  data-aos-delay={item.dealyAnimation}
                >
                  <div className="post-meta">
                    <img
                      src={`${FILE_PATH}/news/${item.images}`}
                      alt="media"
                      className="image-meta mx-auto d-block"
                    />
                    <div className="tag">
                      {moment(item.createdAt).format("DD MMM YYYY")}
                    </div>
                    <h3>
                      <Link to={`/newsarticle/${item.id}`} className="title">
                        {item.title.substring(0, 50)}
                      </Link>
                    </h3>
                    <Link
                      to={`/newsarticle/${item.id}`}
                      className="read-more d-flex justify-content-between align-items-center"
                    >
                      <span>Read More</span>
                      <i className="flaticon-right-arrow"></i>
                    </Link>
                  </div>
                  {/* /.post-meta */}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsArticlePage;
